<template>
  <div id="modalPlan" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Meus Planos</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table v-if="user.clientTypePerson === 1" class="table text-center">
              <thead>
                <tr>
                  <th>Nome do Plano</th>
                  <th>Faixa</th>
                  <th>Número de Usuários</th>
                  <th>Valor Mensal</th>
                  <th>Valor Anual</th>
                  <th>Data de Cadastro</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="plan in plans" :key="plan.id">
                  <td>
                    {{ plan.planName }}
                  </td>
                  <td>
                    {{ plan.customPrice === '1' ? 'Customizado' : plan.range }}
                  </td>
                  <td>
                    {{
                      plan.customPrice === '1'
                        ? plan.numberUser
                        : `${plan.minUser} a ${plan.maxUser}`
                    }}
                  </td>
                  <td>
                    {{
                      plan.typeSignature === '1'
                        ? plan.customPrice === '1'
                          ? moneyToCurrencyBr(
                              plan.numberUser * plan.valueMonthlyPaymentPerUser,
                            )
                          : moneyToCurrencyBr(plan.monthlyPrice)
                        : '-'
                    }}
                  </td>
                  <td>
                    {{
                      plan.typeSignature === '2'
                        ? plan.customPrice === '1'
                          ? moneyToCurrencyBr(
                              plan.numberUser * plan.valueAnnualPaymentPerUser,
                            )
                          : moneyToCurrencyBr(plan.annualPrice)
                        : '-'
                    }}
                  </td>
                  <td>
                    {{ dateTimeSqlToDateTimeBR(plan.createdAt) }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table v-else class="table text-center">
              <thead>
                <tr>
                  <th>Nome do Plano</th>
                  <th>Valor Único</th>
                  <th>Data de Cadastro</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="plan in plans" :key="plan.id">
                  <td>
                    {{ plan.planName }}
                  </td>
                  <td>
                    {{ moneyToCurrencyBr(plan.valueSinglePayment) }}
                  </td>
                  <td>
                    {{ dateTimeSqlToDateTimeBR(plan.createdAt) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer border-top-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { moneyToCurrencyBr } from '@/utils/strings'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import { showModal } from '@/utils/modal'

export default {
  name: 'PlanModal',

  data() {
    return {
      plans: [],
      moneyToCurrencyBr,
      dateTimeSqlToDateTimeBR,
    }
  },

  computed: {
    user() {
      return this.$store.getters.user
    },
  },

  methods: {
    async getPlans() {
      try {
        this.plans = await this.$store.dispatch('getPlansClient')
        showModal('modalPlan')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },
  },

  mounted() {
    this.getPlans()
  },
}
</script>
